import type { Locale } from "@/lib/i18n/config";
import { ThemesPage } from "./ThemesPage";

type ThemeCreatePageProps = {
  locale: Locale;
};

/**
 * `themes/new`: creating opens in a drawer over the list, so this route is
 * the list with the create drawer open. Closing it returns to `themes`.
 */
export function ThemeCreatePage({ locale }: ThemeCreatePageProps) {
  return <ThemesPage locale={locale} createOpen />;
}
